import * as React from 'react'
import { Box } from '@ally/metronome-ui'
import { AdobeTile, AdobeTileContent } from '../../../types'
import XLTile from './XLTile'
import { LoadingRow, LoadingTile } from './XLStyledComponents'

interface TileGroupProps {
  data: AdobeTileContent | null
}

const XLTileGroup: React.FC<TileGroupProps> = ({ data }) => {
  // Limit tiles to render to 3
  const tiles = data?.tiles.slice(0, 3)
  return (
    <Box
      display="flex"
      flexDirection="row"
      flexGrow={1}
      alignItems="flex-start"
      flexBasis="100%"
      justifyContent="space-evenly"
    >
      {!tiles ? (
        <>
          <LoadingTile data-testid="xl-loading-tile-1">
            <LoadingRow />
            <LoadingRow />
            <LoadingRow />
          </LoadingTile>
          <LoadingTile data-testid="xl-loading-tile-2">
            <LoadingRow />
            <LoadingRow />
            <LoadingRow />
          </LoadingTile>
          <LoadingTile data-testid="xl-loading-tile-3">
            <LoadingRow />
            <LoadingRow />
            <LoadingRow />
          </LoadingTile>
        </>
      ) : (
        tiles.map((tileData: AdobeTile, index) => {
          const tileDataKey = `explore-tile-${index}`
          return <XLTile tileData={tileData} key={tileDataKey} />
        })
      )}
    </Box>
  )
}

export default XLTileGroup
